/**
 * Created by andrey on 14.05.18.
 */

const RewardedVideoToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.REWARDED_VIDEO);

    this.nextTime = 0;
    cleverapps.adsLimits.on("update", this.update.bind(this));

    this.update();
};

RewardedVideoToolbarItem.prototype = Object.create(ToolbarItem.prototype);
RewardedVideoToolbarItem.prototype.constructor = RewardedVideoToolbarItem;

RewardedVideoToolbarItem.prototype.update = function () {
    if (this.isAvailable()) {
        this.enable();
    } else {
        this.disable();
    }

    const watchCount = cleverapps.adsLimits.getWatchCount(AdsLimits.TYPES.TOOLBAR);

    if (this.watchCount !== watchCount) {
        this.watchCount = watchCount;
        this.onChangeStateListener();
    }
};

RewardedVideoToolbarItem.prototype.getText = function () {
    const reward = this.getReward();
    if (reward.hard) {
        return `+${reward.hard}$$`;
    }
    return `+${reward.soft}@@`;
};

RewardedVideoToolbarItem.prototype.enable = function () {
    if (!this.enabled) {
        ToolbarItem.prototype.enable.apply(this);
        this.mark();
    }
};

RewardedVideoToolbarItem.prototype.onClick = function () {
    this.disable();

    cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.TOOLBAR, this.giveReward.bind(this));
};

RewardedVideoToolbarItem.prototype.isAvailable = function () {
    return cleverapps.adsLimits.state(AdsLimits.TYPES.TOOLBAR) === AdsLimits.STATE_READY && this.nextTime < Date.now();
};

RewardedVideoToolbarItem.prototype.giveReward = function () {
    this.nextTime = Date.now() + cleverapps.parseInterval(RewardedVideoToolbarItem.TIMEOUT);

    cleverapps.focusManager.displayWhenFreeFocus({
        focus: "RewardedAdToolbarReward",
        action: (f) => {
            new RewardWindow(this.getReward(true), { event: `${cleverapps.EVENTS.EARN.VIDEO}_toolbar` });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

RewardedVideoToolbarItem.prototype.getReward = function (prevReward) {
    let watchCount = cleverapps.adsLimits.getWatchCount(AdsLimits.TYPES.TOOLBAR);

    if (prevReward) {
        watchCount -= 1;
    }

    const rewards = RewardsConfig.RewardedVideoToolbar.hard;
    const amount = rewards[Math.min(watchCount, rewards.length - 1)];

    return { [RewardedVideoToolbarItem.REWARD_CURRENCY]: amount };
};

RewardedVideoToolbarItem.TIMEOUT = "1 minute";
RewardedVideoToolbarItem.REWARD_CURRENCY = "hard";
